import { GridColumnType } from "../../../data/gridColumnType";

export const CommitteApprovalListTableConfig = {
  columns: [
    {
      name: "Name",
      fieldName: "name",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Email Address",
      fieldName: "email",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true
      },
    },
  ],
};
